import React from 'react';

interface ErrorPageProps {
  title: string;
  message: string;
  className?: string;
}

export const ErrorPage: React.FC<ErrorPageProps> = React.memo(
  ({ title, message, className = 'min-h-screen flex items-center justify-center' }) => {
    return (
      <div className={className}>
        <div className="text-center">
          <h1 className="text-2xl font-bold text-ds-text-primary mb-4">{title}</h1>
          <p className="text-ds-text-secondary">{message}</p>
        </div>
      </div>
    );
  }
);
